(ns common.schema.entities.workspace.kyc.templates.capman.contract
    (:require
     [common.schema.entities.workspace.kyc.templates.capman.contract-config :as contract-kyc-config]
     [common.schema.entities.workspace.kyc.templates.capman.company-config :as company-config]
     [common.schema.entities.workspace.kyc.templates.capman.contract-ubo :as contract-ubo]
     [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def mandatory-field-meta
  {:mandatory-field? true})

(def schema
  {:kyc-template/template-name
   "CapMan Contract"

   :kyc-template/kyc-form-preface
   contract-kyc-config/form-preface-text

   :kyc-template/svg-logo
   company-config/svg-logo

   :kyc-template/png-logo
   company-config/png-logo

   :kyc-template/help-email-address
   nil

   :kyc-template/kyc-form-title
   {:translations {:en "CapMan - Know Your Counterparty form"
                   :fi "CapMan - Vastapuolen tunnistamislomake"}}

   :kyc.contract/basic-information
   {:ord          1.0
    :translations {:en "Company's Basic information"
                   :fi "Yrityksen perustiedot"}
    :pdf-columns  2
    :questions    (questions-registry/resolve-questions
                    [[:contract-kyc/business-name mandatory-field-meta]
                     [:contract-kyc/business-id mandatory-field-meta]
                     [:contract-kyc/registered-address mandatory-field-meta]
                     [:contract-kyc/zip-code mandatory-field-meta]
                     [:contract-kyc/city mandatory-field-meta]
                     [:contract-kyc/domicile mandatory-field-meta]])}

   :kyc.contract/actual-beneficiaries
   {:ord
    2.0
    :translations
    {:en "Actual beneficiaries of the company"
     :fi "Yrityksen tosiasialliset edunsaajat"}
    :skip-info?   true

    :info
    {:en
     (str
       "<p>The Act on Money Laundering defines beneficial owner as a person who either
       owns a company or otherwise exercises control over the company.</p>")

     :fi
     (str
       "<p>Rahanpesun torjuntalaki määrittelee tosiasiallisen edunsaajan henkilöksi,
       joka joko omistaa yrityksen tai muuten käyttää määräysvaltaa yhtiön toimien hallitsemiseen.</p>")}
    :more-info
    {:link-text    {:en "More information"
                    :fi "Lisätietoa täällä"}
     :info-header  {:en "Actual Beneficiaries"
                    :fi "Tosiasialliset edunsaajat"}
     :info-content
     {:en
      (str
        "<p>The Act on Money Laundering defines beneficial owner as a person who either
        owns a company or otherwise exercises control over the company.</p>"

        "<p>Beneficial owner status based on ownership or control refers to a natural person who:</p>"

        "<ol>"

        "<li>Directly or indirectly owns more than 25% of the shares of a legal entity or
          otherwise owns a corresponding share of a legal entity;</li>"

        "<li>Directly or indirectly uses more than 25% of the voting rights of a legal entity, and
          this number of votes is based on ownership, membership, articles of association,
          partnership agreement or comparable rules, or;</li>"

        "<li>Otherwise exercises actual control over a legal entity (e.g., based on a shareholder agreement).</li>"

        "</ol>"

        "<p></p>"

        "<p>If the above conditions are not met, the members of the board, the CEO, the liable partner or
        another person in a similar position are considered to be the actual beneficiaries.</p>"

        "<p>The law also directly stipulates who are the actual beneficial owners in
          certain types of associations. These include:</p>"

        "<ol start=\"4\">"

        "<li>An ideological association referred to in the Association Act -
          actual beneficiaries are the members of the board registered in the association register</li>"

        "<li>A religious community referred to in the Freedom of Religion Act -
          beneficial owners are the members of the board registered in the register of religious communities</li>"

        "<li>A foundation referred to in the Foundation Act -
          beneficial owners are the members of the board and administrative council registered in the foundation register</li>"

        "<li>Housing companies and mutual real estate companies referred to in the Housing Companies Act -
          beneficial owners are the members of the board registered in the trade register</li>"

        "</ol>")
      :fi
      (str
        "<p>Rahanpesulaki määrittelee edunsaajan henkilöksi, joka joko omistaa yrityksen tai
        muuten käyttää määräysvaltaa yhtiön toimien hallitsemiseen.</p>"

        "<p>Edunsaajan asema omistuksen tai valvonnan perusteella viittaa luonnolliseen henkilöön, joka:</p>"

        "<ol>"

        "<li>Suoraan tai välillisesti omistaa yli 25% oikeushenkilön osakkeista tai
        muuten omistaa vastaavan osuuden oikeushenkilöstä;</li>"

        "<li>Käyttää suoraan tai välillisesti yli 25% oikeushenkilön äänioikeuksista, ja
        tämä äänimäärä perustuu omistukseen, jäsenyyteen, yhtiöjärjestykseen, osakassopimukseen tai
        vastaaviin sääntöihin, tai; </li>"

        "<li>Muuten harjoittaa todellista valvontaa oikeushenkilön yli (esim. osakassopimuksen perusteella).</li>"

        "</ol>"

        "<p></p>"

        "<p>Jos edellä mainittuja ehtoja ei täytetä, hallituksen jäsenet, toimitusjohtaja,
        vastuullinen kumppani tai muu vastaavassa asemassa oleva henkilö katsotaan todellisiksi edunsaajiksi.</p>"

        "<p>Laki määrittelee myös suoraan, ketkä ovat todellisia edunsaajia tietyntyyppisissä yhdistyksissä.
        Näitä ovat:</p>"

        "<ol start=\"4\">"

        "<li>Yhdistyslakiin viitattava aatteellinen yhdistys -
        todellisia edunsaajia ovat yhdistysrekisteriin rekisteröidyt hallituksen jäsenet.</li>"

        "<li>Uskonnonvapauslakiin viitattava uskonnollinen yhteisö -
        edunsaajia ovat uskonnollisten yhteisöjen rekisteriin rekisteröidyt hallituksen jäsenet.</li>"

        "<li>Säätiölakiin viitattava säätiö - edunsaajia ovat
        säätiörekisteriin rekisteröidyt hallituksen ja hallintoneuvoston jäsenet.</li>"

        "<li>Asunto-osakeyhtiölakiin ja keskinäiseen kiinteistöosakeyhtiölakiin viitatut asunto-osakeyhtiöt ja
        keskinäiset kiinteistöosakeyhtiöt - edunsaajia ovat kaupparekisteriin rekisteröidyt hallituksen jäsenet.</li>"

        "</ol>")}}

    :questions
    (questions-registry/resolve-questions
      [[:contract-kyc/listed-in-stock-exchange? mandatory-field-meta]
       [:contract-kyc/ubo-edn {:data/template    contract-ubo/schema
                               :conditional-field (fn [answers]
                                                    (= (:contract-kyc/listed-in-stock-exchange? answers) :no))
                               :mandatory-field? (fn [answers]
                                                   (= (:contract-kyc/listed-in-stock-exchange? answers) :no))}]])}

   :contract-kyc/confirmation
   {:ord
    12.0
    :translations
    {:en "Confirm entered data is correct"
     :fi "Syötettyjen tietojen vahvistaminen"}
    :questions
    (questions-registry/resolve-questions
      [[:contract-kyc/confirmation-place mandatory-field-meta]
       [:contract-kyc/confirmation-date mandatory-field-meta]
       [:contract-kyc/confirmation-name mandatory-field-meta]])}

   :contract-kyc/identifications
   {:ord
    13.0

    :translations
    {:en "Signer identification"
     :fi "Allekirjoittajien tunnistetiedot"}

    :keep-together?
    true

    :questions
    (let [two-signers? (fn [answers]
                         (= (:contract-kyc/number-of-signers answers) :two))]
      (questions-registry/resolve-questions
        [[:contract-kyc/number-of-signers mandatory-field-meta]
         [:contract-kyc/signer-name-1 mandatory-field-meta]
         [:contract-kyc/signer-email-1 mandatory-field-meta]
         [:contract-kyc/signer-name-2 {:mandatory-field? two-signers?}]
         [:contract-kyc/signer-email-2 {:mandatory-field? two-signers?}]]))}

   :contract-kyc/signature-info
   {:ord
    14.0
    :translations
    {:en ""
     :fi ""}

    :end-of-pdf?
    true

    :page-break-before?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
      [[:contract-kyc/signature-info-1
        {:translations
         {:en (str
                "On behalf of the Company, I hereby confirm that the information "
                "I have declared in this form and in its appendices are true and correct.")
          :fi (str
                "Yrityksen puolesta vakuutan täten, että tässä lomakkeessa ja "
                "sen liitteissä antamani tiedot ovat oikeat ja paikkansapitävät.")}}]
       [:contract-kyc/signature-info-2
        {:translations
         {:en (str
                "By signing the Company Counterparty Information Form I understand that the collected personal data "
                "may be shared and disclosed within the CapMan Group to customer service and "
                "other customer relationship management.")
          :fi (str
                "Allekirjoittamalla yhteistyökumppanin tunnistamislomakkeen ymmärrän, että "
                "kerättyjä henkilötietoja voidaan jakaa ja luovuttaa CapMan-konsernin sisällä "
                "asiakaspalvelulle ja muuhun asiakassuhteen hallintaan.")}}]])}

   :contract-kyc/signature
   {:ord
    15.0

    :translations
    {:en "Signature"
     :fi "Allekirjoitus"}

    :end-of-pdf?
    true

    :conditional-block
    (fn [answers kyc-process]
      (and (some #{(:kyc-process/status kyc-process)}
                 [:kyc-process.status/signatures
                  :kyc-process.status/waiting-for-e-sign])
           (some #{(:contract-kyc/number-of-signers answers)} [:one :two])))

    :section-not-read-only
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
      [[:contract-kyc/signature-place]
       [:contract-kyc/signature-date]
       [:contract-kyc/signature-name]
       [:contract-kyc/signature-signature]])}

   :contract-kyc/signature-2
   {:ord
    16.0

    :translations
    {:en "Signature 2"
     :fi "Allekirjoitus 2"}

    :end-of-pdf?
    true

    :conditional-block
    (fn [answers kyc-process]
      (and (some #{(:kyc-process/status kyc-process)}
                 [:kyc-process.status/signatures
                  :kyc-process.status/waiting-for-e-sign])
           (some #{(:contract-kyc/number-of-signers answers)} [:two])))

    :section-not-read-only
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
      [[:contract-kyc/signature-place-2]
       [:contract-kyc/signature-date-2]
       [:contract-kyc/signature-name-2]
       [:contract-kyc/signature-signature-2]])}})

